var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 4.82463L11.582 3.20668C11.3064 2.93111 10.8596 2.93111 10.5841 3.20668L8.96612 4.82463M11.083 3.41335L11.083 11.881",
    stroke: "#BBBDC0",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84912 11.1755L5.23117 12.7935C4.9556 13.069 4.50882 13.069 4.23325 12.7935L2.61529 11.1755M4.73221 12.5868L4.73221 4.11914",
    stroke: "#61BFCE",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingDescending);
export default __webpack_public_path__ + "static/media/sorting-descending.743094304dd1a89f900914fdc3f986e6.svg";
export { ForwardRef as ReactComponent };